import React from "react";
import { Link } from "react-router-dom";

const Footer: React.FC = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="relative z-10 flex shrink-0 items-center justify-between px-4 md:px-10 h-[62px] bg-[#F5F6F8] border-t border-[#E7E9F0] w-full mt-auto">
      <div className="flex items-center">
        <span className="text-[13px] font-normal text-[#6B7185]">
          © <span className="yr">{currentYear}</span> MolCube, Inc.
        </span>
      </div>
      <div className="flex items-center gap-5">
        <a
          href="https://www.molcube.com/"
          target="_blank"
          rel="noopener noreferrer"
          className="text-[13px] font-medium text-[#4A4F66] hover:underline"
        >
          MolCube
        </a>
        <a
          href="https://apps.molcube.com/"
          target="_blank"
          rel="noopener noreferrer"
          className="text-[13px] font-medium text-[#4A4F66] hover:underline"
        >
          MolCube-Apps
        </a>
        <a
          href="mailto:support@molcube.com"
          className="text-[13px] font-medium text-[#4A4F66] hover:underline"
        >
          Contact
        </a>
      </div>
    </footer>
  );
};

export default Footer;
